import {
  SET_NOTIFICATIONS,
  SET_SELECTED_NOTIFICATION_ID,
  SET_NOTIFICATION_READ
} from './action-types'
import {markNotificationAsRead} from "./logic"

const initialState = {
  notifications: [],
  selectedNotificationId: null
}

export function notificationReducer(state = initialState, action){
  switch (action.type) {

    case SET_NOTIFICATIONS:
      return {
        ...state,
        notifications: action.payload
      }

    case SET_SELECTED_NOTIFICATION_ID:
      return {
        ...state,
        selectedNotificationId: action.payload
      }

    case SET_NOTIFICATION_READ:
      return {
        ...state,
        notifications: markNotificationAsRead(state?.notifications, action.payload)
      }

    default:
      return state
  }

}